import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Card } from "@mui/material";
import FileUploader from "../../FileUploader";
import { endpoints } from "../../../services/apiurl";
import PageTitle from "../../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

const AddPr = () => {
  let history = useHistory();
  const [cat, setCat] = useState({
    status: "",
    image: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelectSuccess = (file) => {
    setSelectedFile(file);
  };

  const handleFileSelectError = ({ error }) => {
    alert(error);
  };
  const [loading, setloading] = useState(false);

  const { media_type, status } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    //console.log(cat);
  };

  useEffect(() => {}, []);

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();
    if (media_type == 1) {
      if (!selectedFile) {
        alert("Please select image");
        return false;
      }
    }

    const formData = new FormData();

    formData.append("image", selectedFile);
    formData.append("status", status);

    await axios.post(endpoints.add_pr, formData).then((response) => {
      setloading(false);
      history.goBack();
    });
  };
  return (
    <div className="ui main">
      <PageTitle title="Add PR Image" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <div className="col col-6">
              <label>Image</label>
              <FileUploader
                onFileSelectSuccess={handleFileSelectSuccess}
                onFileSelectError={handleFileSelectError}
              />
              {selectedFile && (
                <div>
                  <img
                    src={URL.createObjectURL(selectedFile)}
                    alt="Selected Logo"
                    height="200px"
                    width="200px"
                    className="mt-3"
                  />
                </div>
              )}
            </div>

            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddPr;
